import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { compose } from 'redux';
import log from 'loglevel';
import { withApollo } from 'react-apollo';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import useVerfiyClassroom from 'Domain/Classroom/useVerfiyClassroom';
import { getError } from 'Util/classroomProviderUtils';
import { withConfig } from 'Context/ConfigContext';
import { useClassroomSession } from 'Domain/Classroom';
import { useClassroomContext } from 'Context/ClassroomContext';

import ConcurrentModal from '../../Components/ConcurrentModal';
import UnAuthorizationModal from '../UnAuthorizationModal';

const ClassroomVerificationHeartbeat = ({ client, t, appConfig }) => {
  const { classroomVerifyInterval } = appConfig;
  const { logoutCallback } = useClassroomContext();

  const VERIFY_CLASSROOM_INTERVAL_MS = classroomVerifyInterval ?? 30000;
  const { classroomCourseId } = useClassroomSession();

  const verifyClassroomInterval = useRef();
  const history = useHistory();

  const { verifyClassroom, error: verifyClassroomError } = useVerfiyClassroom({
    client,
    onError: (error) => {
      log.error(error);
      const isError =
        !!getError(error?.graphQLErrors, '403') || !!getError(error?.graphQLErrors, '401');
      if (isError) {
        clearInterval(verifyClassroomInterval.current);
      }
    },
  });

  const isConcurrentForbidden = useMemo(
    () => getError(verifyClassroomError?.graphQLErrors, '403'),
    [verifyClassroomError]
  );

  const isUnAuthorization = useMemo(
    () => getError(verifyClassroomError?.graphQLErrors, '401'),
    [verifyClassroomError]
  );

  const handleVerifyClassroom = useCallback(() => {
    if (classroomCourseId) {
      verifyClassroom({ classroomCourseId });
    }
  }, [classroomCourseId, verifyClassroom]);

  useEffect(() => {
    verifyClassroomInterval.current = setInterval(
      handleVerifyClassroom,
      VERIFY_CLASSROOM_INTERVAL_MS
    );

    return () => clearInterval(verifyClassroomInterval.current);
  }, [VERIFY_CLASSROOM_INTERVAL_MS, handleVerifyClassroom]);

  if (verifyClassroomError) log.warn({ verifyClassroomError });

  if (isConcurrentForbidden) {
    return <ConcurrentModal isError={true} onContinue={() => history.push('/')} />;
  }

  if (isUnAuthorization) {
    return <UnAuthorizationModal onLogout={logoutCallback} />;
  }
  return null;
};

export default compose(
  withConfig,
  withApollo,
  withTranslation('classroom')
)(ClassroomVerificationHeartbeat);
